window.createNavigationDialog = function ({ open, close, wrapper, label, render, sidebar = false }) {
  if (!open || !close || !wrapper) return;
  const desktop = window.matchMedia('(min-width: 1024px)');
  let expanded = false;
  let previousOverflow;
  const focusable = () => [...wrapper.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')]
    .filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length);

  function closeMenu(restoreFocus = true) {
    if (!expanded) return;
    expanded = false;
    render(false);
    document.body.style.overflow = previousOverflow;
    open.setAttribute('aria-expanded', 'false');
    wrapper.removeAttribute('aria-modal');
    wrapper.removeAttribute('role');
    wrapper.inert = !sidebar || !desktop.matches;
    if (restoreFocus && !desktop.matches) open.focus({ preventScroll: true });
  }

  open.setAttribute('aria-expanded', 'false');
  open.setAttribute('aria-haspopup', 'dialog');
  if (!wrapper.id) wrapper.id = sidebar ? 'collection-navigation-dialog' : 'navigation-dialog';
  open.setAttribute('aria-controls', wrapper.id);
  wrapper.setAttribute('aria-label', label);
  wrapper.inert = !sidebar || !desktop.matches;
  open.addEventListener('click', () => {
    if (desktop.matches || expanded) return;
    document.dispatchEvent(new Event('navigation:open'));
    previousOverflow = document.body.style.overflow;
    expanded = true;
    wrapper.inert = false;
    wrapper.setAttribute('role', 'dialog');
    wrapper.setAttribute('aria-modal', 'true');
    render(true);
    document.body.style.overflow = 'hidden';
    open.setAttribute('aria-expanded', 'true');
    close.focus({ preventScroll: true });
  });
  close.addEventListener('click', () => closeMenu());
  wrapper.addEventListener('click', event => {
    if (event.target === wrapper) closeMenu();
  });
  document.addEventListener('navigation:open', () => closeMenu(false));
  document.addEventListener('focusin', event => {
    if (expanded && !wrapper.contains(event.target)) close.focus({ preventScroll: true });
  });
  document.addEventListener('keydown', event => {
    if (!expanded) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeMenu();
    } else if (event.key === 'Tab') {
      const elements = focusable();
      const first = elements[0] || close;
      const last = elements[elements.length - 1] || close;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
  desktop.addEventListener('change', () => {
    const hadFocus = wrapper.contains(document.activeElement);
    closeMenu(false);
    wrapper.inert = !sidebar || !desktop.matches;
    if (hadFocus && wrapper.inert) document.querySelector('#main')?.focus({ preventScroll: true });
  });
};
